import { create_instance } from '../init';

class User {
    getUser() {
        return create_instance.get('/user');
    }
    getUserAssets() {
        // return create_instance.get('/user/assets');
        return create_instance.get('/asset'); //?author=testuser4762
    }
}

export default new User();
